/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_0_Table_Rows_0_1Inputs */

const en_gc_search_guides_gridcraft_vs_excel_sections_0_table_rows_0_1 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_0_Table_Rows_0_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open-source, MIT or Apache-2.0; no app subscription.`)
};

const zh_gc_search_guides_gridcraft_vs_excel_sections_0_table_rows_0_1 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_0_Table_Rows_0_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开源，采用 MIT 或 Apache-2.0 许可，应用无需订阅。`)
};

/**
* | output |
* | --- |
* | "Open-source, MIT or Apache-2.0; no app subscription." |
*
* @param {Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_0_Table_Rows_0_1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_vs_excel_sections_0_table_rows_0_1 = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_0_Table_Rows_0_1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_0_Table_Rows_0_1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_vs_excel_sections_0_table_rows_0_1(inputs)
	return zh_gc_search_guides_gridcraft_vs_excel_sections_0_table_rows_0_1(inputs)
});
export { gc_search_guides_gridcraft_vs_excel_sections_0_table_rows_0_1 as "gc.search_guides.gridcraft_vs_excel.sections.0.table.rows.0.1" }